(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["desktop-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dg-desktop-navigation')) {
  customElements.define('dg-desktop-navigation', class extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const options = {signal: this.abortController.signal};
      const buttons = Array.from(this.querySelectorAll('button[aria-controls]'));
      const close = () => {
        buttons.forEach(button => {
          button.setAttribute('aria-expanded', 'false');
          this.querySelector('#' + button.getAttribute('aria-controls')).hidden = true;
        });
      };
      const open = button => {
        close();
        button.setAttribute('aria-expanded', 'true');
        this.querySelector('#' + button.getAttribute('aria-controls')).hidden = false;
      };
      this.addEventListener('wheel', event => {
        if (!event.ctrlKey && buttons.some(button => button.getAttribute('aria-expanded') === 'true')) event.preventDefault();
      }, {...options, passive: false});
      window.addEventListener('scroll', close, {...options, passive: true});
      buttons.forEach(button => {
        button.addEventListener('click', () => {
          open(button);
        }, options);
        button.addEventListener('keydown', event => {
          if (event.key === 'ArrowDown') {
            event.preventDefault();
            open(button);
            this.querySelector('#' + button.getAttribute('aria-controls') + ' a').focus();
          }
        }, options);
        button.parentElement.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') open(button);
        }, options);
      });
      this.querySelectorAll('.header__linklist-item > a').forEach(link => {
        link.parentElement.addEventListener('pointerenter', close, options);
        link.addEventListener('focus', close, options);
      });
      const desktopMedia = window.matchMedia('(min-width: 1200px)');
      desktopMedia.addEventListener('change', close, options);
      this.addEventListener('pointerleave', event => {
        if (event.pointerType === 'mouse') close();
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          const active = buttons.find(button => button.getAttribute('aria-expanded') === 'true');
          close();
          if (active) active.focus();
        }
      }, options);
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) close();
      }, options);
      document.addEventListener('pointerdown', event => {
        if (!this.contains(event.target)) close();
      }, options);
    }
    disconnectedCallback() {
      this.abortController?.abort();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
